module.exports = __webpack_public_path__ + "img/4-2.7d6db12c.svg";